import useFetch from 'elements/Hooks/useFetch'
import { attempt, get } from 'lodash'
import moment from 'moment'
import { handleErrors, handleResponse } from 'modules/Utils'
import React, { createContext, useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { ReactQueryDevtools } from 'react-query/devtools'
import { apiUrl, streamUrl } from 'variables'
import placeholder from './assets/img/placeholder.jpg'
import Authentication from './modules/Authentication'

const auth = new Authentication()

export const GlobalContext = createContext({})

const useReactPath = () => {
  let expiresAt = attempt(() => JSON.parse(localStorage.getItem('expires_at')))
  const isExpires = new Date().getTime() < expiresAt
  const [path, setPath] = useState(isExpires)
  const listenToPopstate = () => {
    let expiresAt = attempt(() => JSON.parse(localStorage.getItem('expires_at')))
    const isExpires = new Date().getTime() < expiresAt

    const winPath = isExpires
    setPath(winPath)
  }
  React.useEffect(() => {
    window.addEventListener('popstate', listenToPopstate)
    return () => {
      window.removeEventListener('popstate', listenToPopstate)
    }
  }, [])
  return path
}

export const GlobalProvider = ({ children }) => {
  const url = window.location.href

  const isLogin = useReactPath()
  const queryClient = useQueryClient()

  const [collapsed, setCollapsed] = useState(true)

  const { data: member, isFetching: fetchingMember, fetch: fetchMember } = useFetch({
    url: 'profiles/member',
    dependencyArray: [isLogin],
    dontFetch: !isLogin,
  })

  const { scopes = [], tenantGroup, tenantGroups, setting, tenantOptions } = member || {}
  const primaryColor = get(tenantGroup, 'primaryColor', 'gray')


  const site = {
    logo: 'https://vendor.rms.africa/static/media/logo.7e64ea8c.png',
    siteTitle: 'RMS',
  }


  const { logo, siteTitle } = site
  const avatar = member?.image
    ? `${streamUrl}files/${member.image}?action=view&access_token=${auth.getAccessToken()}`
    : placeholder

  async function switchTenantGroup(id) {
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `Bearer ${auth.getAccessToken()}`,
    }

    //'corporates/'

    queryClient.invalidateQueries('profiles/member')
    queryClient.invalidateQueries('profiles/member')

    const response = await fetch(`${apiUrl}/profiles/switch?tenantGroup=${id}`, { headers })
      .then(handleErrors)
      .then(handleResponse)

    if (response) {
      fetchMember()
      const token = localStorage.getItem('access_token')
      const loginIp = localStorage.getItem('loginIp')
      const expiresAt = localStorage.getItem('expires_at')

      localStorage.clear()
      sessionStorage.clear()

      localStorage.setItem('access_token', token)
      localStorage.setItem('loginIp', loginIp)
      localStorage.setItem('expires_at', expiresAt)
      localStorage.setItem('member', JSON.stringify(member))
    }
  }

  return (
    <GlobalContext.Provider
      value={{
        member,
        collapsed,
        switchTenantGroup,
        tenantGroup,
        tenantGroups,
        tenantOptions,
        setting,
        fetchingMember,
        fetchMember,
        primaryColor,
        setCollapsed,
        scopes,
        avatar,
        siteTitle,
        logo,
      }}>
      {children}
      {window.location.href.includes('localhost') ? <ReactQueryDevtools /> : null}
    </GlobalContext.Provider>
  )
}
